<template>
    <div>
      <c-table
        ref="table"
        title="개선 목록"
        tableId="impr01"
        :columns="grid.columns"
        :data="grid.data"
        :isExcelDown="true"
        :editable="false"
        :gridHeight="grid.height"
        :merge="grid.merge"
      >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn 
            :disabled="!grid.data || grid.data.length === 0"
            label="개선결과보고서" 
            icon="print"
            @btnClicked="imprResultPrint" />
        </q-btn-group>
      </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name==='actionCompleteRequestDate'">
            <span :style="props.row.approvalStatusCd === 'ASC9999999' ? 'text-decoration: line-through' : ''">
              {{props.row.actionCompleteRequestDate}}
              <q-badge v-if="props.row.completeDateOver > 0
                && props.row.ibmStepCd !== 'IS00000001' && props.row.approvalStatusCd !== 'ASC9999999'" color="negative" label="지연" class="blinking" />
            </span>
            <span v-if="props.row.approvalStatusCd === 'ASC9999999'">
              👉 {{props.row.targetDate}}
            </span>
          </template>
        </template>
      </c-table>
      <c-dialog :param="popupOptions"></c-dialog>
    </div>
  </template>
  
  <script>
  import selectConfig from '@/js/selectConfig';
  export default {
    name: 'impr',
    props: {
      popupParam: {
        type: Object,
        default(){
          return {
            ibmTaskTypeCd: null,
            parentKey: '',
          }
        },
      },
    },
    data() {
      return {
        searchParam: {
          parentKey: '',
          ibmTaskTypeCd: '',
        },
        grid: {
          merge: [
          ],
          columns: [
            
          ],
          data: [],
          height: '700px ',
        },
        editable: true,
        listUrl: '',
        popupOptions: {
          isFull: true,
          target: null,
          title: '',
          visible: false,
          top: '',
          param: {},
          closeCallback: null,
        },
      };
    },
    beforeCreate() {},
    created() {},
    beforeMount() {
      Object.assign(this.$data, this.$options.data());
    },
    mounted() {
      this.init();
    },
    beforeDestroy() {
    },
    computed: {
    },
    methods: {
      init() {
        // role setting
        this.editable = this.$route.meta.editable;
        if (this.popupParam.parentKey) { 
          this.searchParam.parentKey = this.popupParam.parentKey
        }
        if (this.popupParam.ibmTaskTypeCd) { 
          this.searchParam.ibmTaskTypeCd = this.popupParam.ibmTaskTypeCd
        }
        // url setting
        this.listUrl = selectConfig.sop.ibm.improve.relateDetail.url
        this.printUrl = selectConfig.sop.ibm.improve.print.url
        // code setting
        this.setHeader();
        this.getList();
      },
      getList() {
        this.$http.url = this.listUrl;
        this.$http.type = 'GET';
        this.$http.param = this.searchParam;
        this.$http.request((_result) => {
          this.grid.data = _result.data;
        },);
      },
      setHeader() {
        if (this.popupParam.ibmTaskTypeCd === 'ITT0000060') {
          this.grid.merge = [
            { index: 0, colName: 'groupId' },
          ]
          this.grid.columns = [
            {
              name: 'checklistName',
              field: 'checklistName',
              label: '체크리스트 항목',
              align: 'left',
              style: 'width:200px',
              sortable: false,
            },
            {
              name: "selectValueName",
              field: "selectValueName",
              label: "양호/불량/해당없음",
              style: 'width:100px',
              align: "center",
              setHeader: true,
              sortable: false,
            },
            {
              name: 'ibmTitle',
              field: 'ibmTitle',
              label: '제목',
              align: 'left',
              style: 'width:200px',
              sortable: true,
            },
            {
              name: 'improveRequestDeptName',
              field: 'improveRequestDeptName',
              label: '요청부서',
              align: 'center',
              style: 'width:100px',
              sortable: true,
            },
            {
              name: 'improveRequestContents',
              field: 'improveRequestContents',
              label: '요청정보',
              align: 'left',
              style: 'width:200px',
              sortable: true,
            },
            {
              name: 'actionCompleteRequestDate',
              field: 'actionCompleteRequestDate',
              label: '조치완료 요청일',
              align: 'center',
              style: 'width:100px',
              type: 'custom',
              sortable: true,
            },
            {
              name: 'actionDeptName',
              field: 'actionDeptName',
              label: '조치부서',
              align: 'center',
              style: 'width:100px',
              sortable: true,
            },
            {
              name: 'actionCompleteDate',
              field: 'actionCompleteDate',
              label: '조치완료일',
              align: 'center',
              style: 'width:90px',
              sortable: true,
            },
            {
              name: 'beforeImage',
              field: 'beforeImage',
              label: '조치 전 사진',
              align: 'center',
              style: 'width:100px',
              type: 'img',
              // taskClassCd: 'IBM_AFTER',
              sortable: false,
            },
            {
              name: 'afterImage',
              field: 'afterImage',
              label: '조치 후 사진',
              align: 'center',
              style: 'width:100px',
              type: 'img',
              // taskClassCd: 'IBM_AFTER',
              sortable: false,
            },
          ]
        } else 
        if (this.popupParam.ibmTaskTypeCd === 'ITT0000135') {
          this.grid.merge = [
            { index: 0, colName: 'groupId' },
          ]
          this.$comm.getComboItems('ENV_PATROL_RESULT_CD').then(_result => {
            this.grid.columns = [
              {
                name: 'patrolItemName',
                field: 'patrolItemName',
                label: '점검항목',
                style: 'width:200px',
                align: 'left',
                sortable: false,
              },
              {
                name: 'patrolResultCd',
                field: 'patrolResultCd',
                align: 'center',
                label: '점검결과',
                type: 'select',
                isChip: true,
                none: true,
                style: 'width:100px',
                comboItems: _result,
                sortable: false,
              },
              {
                name: 'ibmTitle',
                field: 'ibmTitle',
                label: '제목',
                align: 'left',
                style: 'width:200px',
                sortable: true,
              },
              {
                name: 'improveRequestDeptName',
                field: 'improveRequestDeptName',
                label: '요청부서',
                align: 'center',
                style: 'width:100px',
                sortable: true,
              },
              {
                name: 'improveRequestContents',
                field: 'improveRequestContents',
                label: '요청정보',
                align: 'left',
                style: 'width:200px',
                sortable: true,
              },
              {
                name: 'actionCompleteRequestDate',
                field: 'actionCompleteRequestDate',
                label: '조치완료 요청일',
                align: 'center',
                style: 'width:100px',
                type: 'custom',
                sortable: true,
              },
              {
                name: 'actionDeptName',
                field: 'actionDeptName',
                label: '조치부서',
                align: 'center',
                style: 'width:100px',
                sortable: true,
              },
              {
                name: 'actionCompleteDate',
                field: 'actionCompleteDate',
                label: '조치완료일',
                align: 'center',
                style: 'width:90px',
                sortable: true,
              },
              {
                name: 'beforeImage',
                field: 'beforeImage',
                label: '조치 전 사진',
                align: 'center',
                style: 'width:100px',
                type: 'img',
                // taskClassCd: 'IBM_AFTER',
                sortable: false,
              },
              {
                name: 'afterImage',
                field: 'afterImage',
                label: '조치 후 사진',
                align: 'center',
                style: 'width:100px',
                type: 'img',
                // taskClassCd: 'IBM_AFTER',
                sortable: false,
              },
            ]
          })
        }
      },
      imprResultPrint() {
        let thisVue = this;
        this.$http.url = this.printUrl;
        this.$http.type = 'GET';
        this.$http.param = this.searchParam
        this.$http.request(
          _result => {
            let fileOrgNm = '개선 결과 보고서_' + this.$comm.getToday() + '.xlsx';
            let blob = thisVue.$comm.base64ToBlob(_result.data);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
            } else {
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileOrgNm;
              link.click();
            }
          }, () => { }
        );
      }
    }
  };
  </script>
  